import { createSlice } from '@reduxjs/toolkit'
import { getInboxes } from '../lib/api'

export const inboxesSlice = createSlice({
  name: 'inboxes',
  initialState: {
    inboxes: {},
    inboxesValues: [],
    loaded: false,
    loading: false,
    error: null
  },
  reducers: {
    loading: state => {
      state.loading = true
    },
    load: (state, { payload }) => {
      state.inboxes = payload
      state.inboxesValues = Object.values(payload)
      state.loaded = true
      state.loading = false
    },
    failed: (state, { payload }) => {
      state.error = payload
      state.loading = false
      state.loaded = true
    }
  }
})

export default inboxesSlice.reducer

export const { loading, load, failed } = inboxesSlice.actions

// Asynchronous thunk action
export function fetchInboxes () {
  return async dispatch => {
    dispatch(loading())
    try {
      const inboxes = await getInboxes()
      const filtered = inboxes.filter(obj => Boolean(obj.name))
      const toSet = {}
      filtered.forEach(type => {
        toSet[type.id] = type
      })
      dispatch(load(toSet))
    } catch (error) {
      dispatch(failed(error))
    }
  }
}
